import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import R from 'ramda';

const generateToggleIcon = ({ isCountrySelectorVisible, showToggleIcon }) => {
  if (showToggleIcon) {
    return isCountrySelectorVisible ? ' -' : ' +';
  }
  return '';
};

export const generateCountrySelectorButtonClassNames = ({ extraClass }) => classNames(
  'button',
  'country-selector-button',
  extraClass,
);

const CountrySelectorButton = ({
  isCountrySelectorVisible,
  toggleCountrySelector,
  extraClass,
  current,
  showToggleIcon = true,
}) => (
  <div className="country-selector-button">
    <button
      data-test="country-selector-button"
      className={generateCountrySelectorButtonClassNames({ extraClass })}
      onClick={toggleCountrySelector}
    >
      {R.prop('country')(current)} ({R.prop('language')(current)})
      {generateToggleIcon({ isCountrySelectorVisible, showToggleIcon })}
    </button>
  </div>
);

CountrySelectorButton.propTypes = {
  isCountrySelectorVisible: PropTypes.bool,
  showToggleIcon: PropTypes.bool,
  toggleCountrySelector: PropTypes.func,
  extraClass: PropTypes.string,
  current: PropTypes.shape({
    country: PropTypes.string,
    language: PropTypes.string,
  }).isRequired,
};

export default CountrySelectorButton;
